import type { ReactNode } from 'react'
import { ClipboardList, Download, Plus } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import Spinner from '~/components/Spinner'
import { Button } from '~/components/ui/button'
import { tourAnchor } from '~/helpers/tour/anchors'
import { TableToolbar, ToolbarActions } from '~/pages/backoffice/TableToolbar'

type IProps = {
  loading: boolean
  count: number
  empty: string
  newLabel: string
  onNew: () => void
  onExport: () => void
  /** Le tableau des entrées, rendu quand il y en a. */
  children: ReactNode
}

/** La mise en page commune aux deux registres qualité (#328) : exporter, ajouter, la liste. */
function QualityRegister({ loading, count, empty, newLabel, onNew, onExport, children }: IProps) {
  const { t } = useTranslation()

  return (
    <div className="flex flex-col gap-4">
      <TableToolbar>
        <ToolbarActions>
          <Button variant="outline" onClick={onExport} disabled={count === 0} {...tourAnchor('quality.export')}>
            <Download className="mr-2 size-4" />
            {t('quality.export')}
          </Button>
          <Button onClick={onNew} {...tourAnchor('quality.new')}>
            <Plus className="mr-2 size-4" />
            {newLabel}
          </Button>
        </ToolbarActions>
      </TableToolbar>
      <div {...tourAnchor('quality.list')}>
        {loading
          ? <div className="flex justify-center p-10"><Spinner className="size-6" /></div>
          : count === 0
            ? (
                <div className="flex flex-col items-center gap-3 rounded-lg border border-dashed p-10 text-center text-muted-foreground">
                  <ClipboardList className="size-8" />
                  <p className="text-sm">{empty}</p>
                </div>
              )
            : <div className="overflow-x-auto rounded-lg border">{children}</div>}
      </div>
    </div>
  )
}

export default QualityRegister
